import React from 'react';
import formatSize from 'pretty-bytes';
import { Slug } from '@isyc-react/animation/modules/base/trail';
import { useTranslation } from 'react-i18next';
import { RippleButton } from '@isyc-react/form/modules/base/button';
import { DropFileError } from '@isyc-react/form-file/modules/drop-file/drop-status/drop-common';
import '@isyc-react/design/main';
import { nsformfile } from '@isyc-react/form-file/i18n/namespaces';
import { OverlayTrigger, Tooltip } from '@isyc-react/design/bootstrap';
const RejectedFileError = props => {
    var _a;
    const { file, error } = props;
    const { i18n, t } = useTranslation(nsformfile.common);
    switch (error.code) {
        case DropFileError.TOO_MANY_FILES:
            return React.createElement("small", { className: 'text-danger' }, t('drop.rejected.reason.tooManyFiles'));
        case DropFileError.INVALID_TYPE:
            return (React.createElement("small", { className: 'text-danger' }, t('drop.rejected.reason.invalidType', { ext: (_a = file.name.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase() })));
        case DropFileError.TOO_LARGE:
            return (React.createElement("small", { className: 'text-danger' }, t('drop.rejected.reason.tooLarge', { size: formatSize(props.file.size, { locale: i18n.language }) })));
        case DropFileError.TOO_SMALL:
            return (React.createElement("small", { className: 'text-danger' }, t('drop.rejected.reason.tooSmall', { size: formatSize(props.file.size, { locale: i18n.language }) })));
        default:
            return React.createElement("small", { className: 'text-danger' }, t('drop.rejected.reason.default'));
    }
};
export const DropSingleRejectedView = props => {
    const { rejected, open, remove, disabled } = props;
    const { t } = useTranslation(nsformfile.common);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'd-flex align-items-center justify-content-between flex-wrap' },
            React.createElement(Slug, { delay: 100, config: { tension: 100, friction: 10 }, from: { opacity: 0, transform: 'translate3d(0px,50px,0)' } },
                React.createElement("div", null, rejected.map((rejection, i) => (React.createElement(React.Fragment, { key: i },
                    React.createElement("div", { className: 'd-flex align-items-center' },
                        React.createElement("div", { className: 'text-start' },
                            React.createElement("p", { className: 'text-red fw-bold' },
                                React.createElement("i", { className: 'mdi mdi-close text-red' }),
                                " ",
                                rejection.file.name))),
                    React.createElement("div", { className: 'd-flex flex-column justify-content-start' },
                        React.createElement(Slug, { delay: 100, config: { tension: 100, friction: 10 }, from: { opacity: 0, transform: 'translate3d(0px,50px,0)' } }, rejection.errors.map((error, j) => (React.createElement(React.Fragment, { key: j },
                            React.createElement("div", null,
                                React.createElement(RejectedFileError, { file: rejection.file, error: error }))))))))))))),
        React.createElement("div", { className: 'd-flex justify-content-center mt-3' },
            React.createElement(OverlayTrigger, { overlay: React.createElement(Tooltip, null, "Modifier") },
                React.createElement(RippleButton, { className: 'btn btn-lg btn-pill btn-outline-primary only-icon me-2', onClick: open, disabled: disabled },
                    React.createElement("i", { className: 'mdi mdi-pen text-black font-size-17 fw-bold' }))),
            React.createElement(OverlayTrigger, { overlay: React.createElement(Tooltip, null, "Supprimer") },
                React.createElement(RippleButton, { type: 'button', className: 'btn btn-lg btn-pill btn-outline-danger only-icon me-2', onClick: remove, disabled: disabled },
                    React.createElement("i", { className: 'mdi mdi-close text-danger font-size-17 fw-bold' }))))));
};
